import styled from 'styled-components';

const StyledGeolocation = styled.div`
  color: #fff;
  h1 {
    color: #fff;
    font-size: 2.5rem;
    font-weight: 500;
    margin-bottom: 5px;
  }
  h3 {
    font-size: 1rem;
  }
`

export default StyledGeolocation;
